import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput"

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            casillaUVT_id: null,
            casillaOTT_id: null,
            casillaInforme_id: null,
            casillaInformeConfirmacion_id: null,
            casillaSolicitarFactura_id: null,
            casillaSeparacionImputaciones_id: null,
            plantillaUVT_id: null,
            plantillaOTT_id: null,
            plantillaInforme_id: null,
            plantillaInformeConfirmacion_id: null,
            plantillaSolicitarFactura_id: null,
            plantillaSeparacionImputaciones_id: null,
            casillaImputacionesEnvioOTT_id: null,
            plantillaImputacionesEnvioOTT_id: null,
        };
    }

    static propTypes = {
        nav: PropTypes.any,
    }

    getData = () => {
        return {
            casillaUVT_id: this.state.casillaUVT_id,
            casillaOTT_id: this.state.casillaOTT_id,
            casillaInforme_id: this.state.casillaInforme_id,
            casillaInformeConfirmacion_id: this.state.casillaInformeConfirmacion_id,
            casillaSolicitarFactura_id: this.state.casillaSolicitarFactura_id,
            casillaSeparacionImputaciones_id: this.state.casillaSeparacionImputaciones_id,
            plantillaUVT_id: this.state.plantillaUVT_id,
            plantillaOTT_id: this.state.plantillaOTT_id,
            plantillaInforme_id: this.state.plantillaInforme_id,
            plantillaInformeConfirmacion_id: this.state.plantillaInformeConfirmacion_id,
            plantillaSolicitarFactura_id: this.state.plantillaSolicitarFactura_id,
            plantillaSeparacionImputaciones_id: this.state.plantillaSeparacionImputaciones_id,
            casillaImputacionesEnvioOTT_id: this.state.casillaImputacionesEnvioOTT_id,
            plantillaImputacionesEnvioOTT_id: this.state.plantillaImputacionesEnvioOTT_id,
        };
    }

    resetForm() {
        this.setState({
            casillaUVT_id: null,
            casillaOTT_id: null,
            casillaInforme_id: null,
            casillaInformeConfirmacion_id: null,
            casillaSolicitarFactura_id: null,
            casillaSeparacionImputaciones_id: null,
            plantillaUVT_id: null,
            plantillaOTT_id: null,
            plantillaInforme_id: null,
            plantillaInformeConfirmacion_id: null,
            plantillaSolicitarFactura_id: null,
            plantillaSeparacionImputaciones_id: null,
            casillaImputacionesEnvioOTT_id: null,
            plantillaImputacionesEnvioOTT_id: null,
        });
    }

    setSelects(data) {
        this.setState({
            casillaUVT_id: data.casillaUVT_id,
            casillaOTT_id: data.casillaOTT_id,
            casillaInforme_id: data.casillaInforme_id,
            casillaInformeConfirmacion_id: data.casillaInformeConfirmacion_id,
            casillaSolicitarFactura_id: data.casillaSolicitarFactura_id,
            casillaSeparacionImputaciones_id: data.casillaSeparacionImputaciones_id,
            plantillaUVT_id: data.plantillaUVT_id,
            plantillaOTT_id: data.plantillaOTT_id,
            plantillaInforme_id: data.plantillaInforme_id,
            plantillaInformeConfirmacion_id: data.plantillaInformeConfirmacion_id,
            plantillaSolicitarFactura_id: data.plantillaSolicitarFactura_id,
            plantillaSeparacionImputaciones_id: data.plantillaSeparacionImputaciones_id,
            casillaImputacionesEnvioOTT_id: data.casillaImputacionesEnvioOTT_id,
            plantillaImputacionesEnvioOTT_id: data.plantillaImputacionesEnvioOTT_id,
        });
    }

    render() {
        return (
            <ParadigmaModal
                navButton={(this.props.nav ? true : false)}
                nav={this.props.nav}
                getUrl={api.configuracion.edit}
                postUrl={api.configuracion.edit}
                onPreSubmit={this.getData}
                id={this.props.id}
                successMessage={"La Configuración ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Configuración"}
                buttonTitle={"Editar"}
                buttonIcon={"fa fa-pencil fa-lg"}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
            >

                <ParadigmaLabeledInput label={"Casilla UVT"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        url={api.email.casillas.select}
                        fieldName={"casillaUVT_id"}
                        value={this.state.casillaUVT_id}
                        onChange={(data) => this.setState({ casillaUVT_id: (data ? data.pk : null) })}
                    />} />
                <ParadigmaLabeledInput label={"Plantilla UVT"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        nombreField={"descripcion"}
                        url={api.email.plantillas.select}
                        fieldName={"plantillaUVT_id"}
                        value={this.state.plantillaUVT_id}
                        onChange={(data) => this.setState({ plantillaUVT_id: (data ? data.pk : null) })}
                    />}
                />

                <hr></hr>

                <ParadigmaLabeledInput label={"Casilla OTT"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        url={api.email.casillas.select}
                        fieldName={"casillaOTT_id"}
                        value={this.state.casillaOTT_id}
                        onChange={(data) => this.setState({ casillaOTT_id: (data ? data.pk : null) })}
                    />} />
                <ParadigmaLabeledInput label={"Plantilla OTT"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        nombreField={"descripcion"}
                        url={api.email.plantillas.select}
                        fieldName={"plantillaOTT_id"}
                        value={this.state.plantillaOTT_id}
                        onChange={(data) => this.setState({ plantillaOTT_id: (data ? data.pk : null) })}
                    />}
                />

                <hr></hr>

                <ParadigmaLabeledInput label={"Casilla Informes"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        url={api.email.casillas.select}
                        fieldName={"casillaInforme_id"}
                        value={this.state.casillaInforme_id}
                        onChange={(data) => this.setState({ casillaInforme_id: (data ? data.pk : null) })}
                    />} />
                <ParadigmaLabeledInput label={"Plantilla Informes"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        nombreField={"descripcion"}
                        url={api.email.plantillas.select}
                        fieldName={"plantillaInforme_id"}
                        value={this.state.plantillaInforme_id}
                        onChange={(data) => this.setState({ plantillaInforme_id: (data ? data.pk : null) })}
                    />} />


                <hr></hr>

                <ParadigmaLabeledInput label={"Casilla Informes (Confirmación)"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        url={api.email.casillas.select}
                        fieldName={"casillaInformeConfirmacion_id"}
                        value={this.state.casillaInformeConfirmacion_id}
                        onChange={(data) => this.setState({ casillaInformeConfirmacion_id: (data ? data.pk : null) })}
                    />} />
                <ParadigmaLabeledInput label={"Plantilla Informes (Confirmación)"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        nombreField={"descripcion"}
                        url={api.email.plantillas.select}
                        fieldName={"plantillaInformeConfirmacion_id"}
                        value={this.state.plantillaInformeConfirmacion_id}
                        onChange={(data) => this.setState({ plantillaInformeConfirmacion_id: (data ? data.pk : null) })}
                    />} />


                <hr></hr>

                <ParadigmaLabeledInput label={"Casilla Solicitar Factura"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        url={api.email.casillas.select}
                        fieldName={"casillaSolicitarFactura_id"}
                        value={this.state.casillaSolicitarFactura_id}
                        onChange={(data) => this.setState({ casillaSolicitarFactura_id: (data ? data.pk : null) })}
                    />} />
                <ParadigmaLabeledInput label={"Plantilla Solicitar Factura"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        nombreField={"descripcion"}
                        url={api.email.plantillas.select}
                        fieldName={"plantillaSolicitarFactura_id"}
                        value={this.state.plantillaSolicitarFactura_id}
                        onChange={(data) => this.setState({ plantillaSolicitarFactura_id: (data ? data.pk : null) })}
                    />}
                />

                <hr />

                <ParadigmaLabeledInput label={"Casilla Imputaciones"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        url={api.email.casillas.select}
                        fieldName={"casillaSeparacionImputaciones_id"}
                        value={this.state.casillaSeparacionImputaciones_id}
                        onChange={(data) => this.setState({ casillaSeparacionImputaciones_id: (data ? data.pk : null) })}
                    />}
                />

                <ParadigmaLabeledInput label={"Plantilla Imputaciones"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        nombreField={"descripcion"}
                        url={api.email.plantillas.select}
                        fieldName={"plantillaSeparacionImputaciones_id"}
                        value={this.state.plantillaSeparacionImputaciones_id}
                        onChange={(data) => this.setState({ plantillaSeparacionImputaciones_id: (data ? data.pk : null) })}
                    />}
                />

                <hr />

                <ParadigmaLabeledInput label={"Casilla Imputaciones - Envio OTT"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        url={api.email.casillas.select}
                        fieldName={"casillaImputacionesEnvioOTT_id"}
                        value={this.state.casillaImputacionesEnvioOTT_id}
                        onChange={(data) => this.setState({ casillaImputacionesEnvioOTT_id: (data ? data.pk : null) })}
                    />}
                />

                <ParadigmaLabeledInput label={"Plantilla Imputaciones - Envio OTT"} labelColumns={4} fieldColumns={8}
                    inputComponent={<ParadigmaAsyncSeeker
                        clearable={true}
                        nombreField={"descripcion"}
                        url={api.email.plantillas.select}
                        fieldName={"plantillaImputacionesEnvioOTT_id"}
                        value={this.state.plantillaImputacionesEnvioOTT_id}
                        onChange={(data) => this.setState({ plantillaImputacionesEnvioOTT_id: (data ? data.pk : null) })}
                    />}
                />

            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Configuraciones/Edit.js